/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log(
	"Hello World! (from create-block-agenturschmucki-references block)",
);
/* eslint-enable no-console */


	document.querySelectorAll(".accordion-toggle").forEach((toggle) => {
		toggle.addEventListener("click", () => {
			toggle.closest(".accordion-wrapper").classList.toggle("open");
		});
	});

	// // Dynamisch Icon-Größe an Button-Höhe anpassen
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.accordion-toggle-wrapper').forEach(wrapper => {
			const summary = wrapper.querySelector('.accordion-summary');
			const icon = wrapper.querySelector('.accordion-icon');

			// Funktion zum Setzen von Breite und Höhe
			const updateIcon = () => {
				const height = summary.offsetHeight;
				icon.style.width = height + 'px';
				icon.style.height = height + 'px';
			};

			// Initial ausführen
			updateIcon();
			// Beobachter für dynamische Änderungen
			const ro = new ResizeObserver(updateIcon);
			ro.observe(summary);
			// auch bei Fenster-Resize nachjustieren
			window.addEventListener('resize', updateIcon);
		});
	});
